module.exports = __webpack_public_path__ + "static/img/4.c5a82bb0.jpg";